module.exports = __webpack_public_path__ + "img/cg.4396b867.svg";